export default __webpack_public_path__ + "static/media/GitHub.20621640.svg";